import { createAction, props } from '@ngrx/store'
import { ModuleDashboardAPIModel, PaginatedAPI, QueriesAPIModel } from 'src/app/models/api.model'

const QUERY = '[query]'

export const fetch_query_dashboard_data = createAction(
  `${QUERY} fetch_query_dashboard_data`,
  props<{ days: number; sortBy: string; sortOrder: string }>()
)
export const fetch_query_dashboard_data_success = createAction(
  `${QUERY} fetch_query_dashboard_data_success`,
  props<ModuleDashboardAPIModel>()
)

export const save_query_action = createAction(
  `${QUERY} save_query_action`,
  props<{ query: QueriesAPIModel; files: FileList; routeTo: string }>()
)

export const save_query_success_action = createAction(
  `${QUERY} save_query_success_action`,
  props<{ query: QueriesAPIModel; routeTo: string }>()
)

export const FETCH_QUERY_DETAILS = createAction(`${QUERY} fetch_query_details`, props<{ id: string }>())

export const FETCH_QUERY_DETAILS_SUCCESS = createAction(
  `${QUERY} fetch_query_details_success`,
  props<{ query: QueriesAPIModel }>()
)

export const UPDATE_QUERY_ACTION = createAction(
  `${QUERY} update_query_action`,
  props<{ query: Partial<QueriesAPIModel>; id: string; files: File[]; routeTo: string }>()
)

export const UPDATE_QUERY_SUCCESS_ACTION = createAction(
  `${QUERY} update_query_success_action`,
  props<{ query: Partial<QueriesAPIModel>; routeTo: string }>()
)

export const DELETE_QUERY_DETAILS = createAction(`${QUERY} DELETE_QUERY_DETAILS`)

export const load_query_summary_action = createAction(
  `${QUERY}  load_query_summary_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)
export const load_query_summary_success_action = createAction(
  `${QUERY}  load_query_summary_success_action`,
  props<{ query: PaginatedAPI<QueriesAPIModel> }>()
)
